import React, { useState } from "react";
import Datepicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa";
import Style from "./datepicker.module.scss";
import PropTypes from "prop-types";
import { dMMMyyyy } from "../../utils/constants/appConstants";

const CustomerPayDatePicker = ({ initialDate, onDateChange, loading }) => {
  const [selectedDate, setSelectedDate] = useState(initialDate);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    onDateChange(date);
  };

  return (
    <div className={Style.datepickerWithicon}>
      <Datepicker
        className={`${Style.datepicercustom} ${Style.datepicercustomheight}`}
        selected={selectedDate}
        onChange={handleDateChange}
        dateFormat={dMMMyyyy}
        disabled={loading}
      />
      <span>
        <FaCalendarAlt />
      </span>
    </div>
  );
};
CustomerPayDatePicker.propTypes = {
  initialDate: PropTypes.instanceOf(Date),
  onDateChange: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};

export default CustomerPayDatePicker;
